import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "preview-block" }
const _hoisted_2 = { class: "preview-header" }
const _hoisted_3 = { class: "preview-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { mdiClose } from "@mdi/js";
import { computed } from "vue";

import { useUIContentStore } from "@/stores/ui-content.store";

import { getFileNameFromURL } from "@/utils/file-helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPreview',
  setup(__props) {

const uiContentStore = useUIContentStore();

const getContentLink = (): string => {
  if (uiContentStore.fileLocationForPreview) {
    if (uiContentStore.fileLocationForPreview.includes("youtu")) {
      const linkWithoutPostfix =
        uiContentStore.fileLocationForPreview.split("&")[0];
      const prefixesToSearch = [
        "watch?v=",
        "v/",
        "watch?vi=",
        "vi/",
        "e/",
        "?v="
      ];
      const searchValue = prefixesToSearch.find((element: string) => {
        return linkWithoutPostfix.includes(element);
      });
      if (linkWithoutPostfix.includes("youtube")) {
        return searchValue
          ? linkWithoutPostfix.replace(searchValue, "embed/")
          : "";
      }
      if (linkWithoutPostfix.includes("youtu.be")) {
        return (
          "https://www.youtube.com/embed/" +
          linkWithoutPostfix.split("https://youtu.be")[1]
        );
      }
    }
    if (uiContentStore.fileLocationForPreview.includes("onedrive")) {
      return uiContentStore.fileLocationForPreview.replaceAll("&amp;", "&");
    }
    return uiContentStore.fileLocationForPreview;
  }
  return "";
};
const checkIfExternalContentIsImage = (): boolean => {
  const contentLink = getContentLink();
  return !!contentLink && contentLink.match(/\.(jpeg|jpg|gif|png)$/) !== null;
};

const fileName = computed<string>(() => {
  if (!uiContentStore.fileLocationForPreview) {
    return "";
  }
  if (uiContentStore.fileLocationForPreview.includes("youtu")) {
    const videoId = getContentLink().split("embed/")[1];
    return videoId ? `YouTube video: ${videoId}` : "YouTube video";
  }
  return getFileNameFromURL(uiContentStore.fileLocationForPreview);
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, "Preview: " + _toDisplayString(fileName.value), 1),
      _createElementVNode("button", {
        class: "btn-3",
        title: "Close Preview",
        "aria-label": "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closePreview'))),
        "data-testing": "close-right-sidebar"
      }, [
        _createVNode(_component_SVGIcon, {
          path: _unref(mdiClose),
          type: "is-white",
          size: "24"
        }, null, 8, ["path"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (checkIfExternalContentIsImage())
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "content",
            src: getContentLink(),
            alt: "image"
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            class: "content",
            src: getContentLink()
          }, null, 8, _hoisted_5))
    ])
  ]))
}
}

})